import React from 'react'
import { connect } from 'react-redux'
import InventoryActions from '../../Redux/InventoryRedux'
import SupplierActions from '../../Redux/SupplierRedux'
import Select from 'react-select'
import Toggle from 'react-toggle'

class UpdateInventory extends React.Component {
  constructor (props) {
    super(props)
    this.discount_type = [
      { value: 'PRICE_CUT', label: 'PRICE_CUT' },
      { value: 'PERCENTAGE_CUT', label: 'PERCENTAGE_CUT' }
    ]
    this.iso_code = [
      { value: 'ID', label: 'ID' },
      { value: 'PH', label: 'PH' }
    ]
    this.state = {
      selectedNum: undefined,
      selectedCategory: props.selectedCategory,
      selectedBrand: props.selectedBrand,
      selectedSupplier: props.selectedSupplier,
      featured: props.detail.is_featured === 1,
      status: props.detail.status === 1,
      isDiscount: props.detail.discount_type === 'PERCENTAGE_CUT',
      form: {
        sku_m: props.detail.sku_m,
        category_id: props.detail.category_id,
        brand_id: props.detail.brand_id,
        supplier_id: props.detail.supplier_id,
        name: props.detail.name,
        status: props.detail.status,
        is_featured: props.detail.is_featured,
        buy_price: props.detail.buy_price,
        normal_price: props.detail.normal_price,
        discount_type: props.detail.discount_type,
        discount: props.detail.discount,
        weight: props.detail.weight,
        dimension: props.detail.dimension,
        description: props.detail.description,
        supplier: props.detail.supplier,
        iso_code: props.detail.iso_code,
        currency_code: props.detail.currency_code
      }
    }
  }

  componentDidMount () {
    this.props.getSupplier()
  }

  _inputChange = (event, field) => {
    let form = { ...this.state.form }
    if (field === 'is_featured') {
      let value = event.target.checked
      let featured = this.state.featured
      form.is_featured = value
      featured = !featured
      this.setState({ form, featured })
    } else if (field === 'status') {
      let value = event.target.checked
      let status = this.state.status
      form.status = value
      status = !status
      this.setState({ form, status })
    } else {
      let value = event.target.value
      form[field] = value
      this.setState({ form })
    }
  }

  _discountTypeChange = (event) => {
    let form = { ...this.state.form }
    let value = event.target.value
    if (value === 'PERCENTAGE_CUT') {
      this.setState({ isDiscount: true })
    } else if (value === 'PRICE_CUT') {
      this.setState({ isDiscount: false })
    }
    form.discount_type = value
    this.setState({ form })
  }

  _categoryChange = (selectedCategory) => {
    let form = { ...this.state.form }
    let selectedNum = selectedCategory.selectedNum
    form.category_id = selectedCategory.value
    this.setState({
      selectedBrand: '',
      selectedCategory,
      selectedNum,
      form
    })
  }

  _brandChange = (selectedBrand) => {
    let form = { ...this.state.form }
    form.brand_id = selectedBrand.value
    this.setState({ selectedBrand, form })
  }

  _supplierChange = (selectedSupplier) => {
    let form = { ...this.state.form }
    form.supplier_id = selectedSupplier.value
    this.setState({ selectedSupplier, form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    this.state.featured === true
      ? form.is_featured = 1
      : form.is_featured = 0
    this.state.status === true
      ? form.status = 1
      : form.status = 0
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.updateInventory(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { category } = this.props
    const categoryPicker = []
    let brandPicker = []
    let supplierPicker = []

    category.data.map((item, i) => {
      categoryPicker[i] = {
        value: item.id,
        label: item.name,
        selectedNum: i
      }
      return categoryPicker
    })

    if (category.data.length > 0) {
      if (this.state.selectedNum === undefined) {
        brandPicker = []
      } else {
        category.data[this.state.selectedNum].brand.map((item, i) => {
          brandPicker[i] = {
            value: item.id,
            label: item.name
          }
          return brandPicker
        })
      }
    }

    this.props.supplier.data.map(supplier => {
      supplierPicker.push({
        value: supplier.id,
        label: supplier.name
      })
      return supplier
    })

    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Inventory</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Name</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                className='form-control'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Status</label>
            </div>
            <div className='col-9'>
              <Toggle
                checked={this.state.status}
                onChange={(event) => this._inputChange(event, 'status')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Featured</label>
            </div>
            <div className='col-9'>
              <Toggle
                checked={this.state.featured}
                onChange={(event) => this._inputChange(event, 'is_featured')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>SKU Master</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                className='form-control'
                value={this.state.form.sku_m}
                onChange={(event) => this._inputChange(event, 'sku_m')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Category</label>
            </div>
            <div className='col-9'>
              <Select
                options={categoryPicker}
                name='category-picker'
                required
                value={this.state.selectedCategory}
                onChange={(selectedCategory) => this._categoryChange(selectedCategory)}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Brand</label>
            </div>
            <div className='col-9'>
              <Select
                isDisabled={this.state.selectedNum === undefined}
                options={brandPicker}
                name='brand-picker'
                value={this.state.selectedBrand}
                onChange={(selectedBrand) => this._brandChange(selectedBrand)}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Buy Price</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                required
                className='form-control'
                value={this.state.form.buy_price}
                onChange={(event) => this._inputChange(event, 'buy_price')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Normal Price</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                required
                className='form-control'
                value={this.state.form.normal_price}
                onChange={(event) => this._inputChange(event, 'normal_price')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Discount Type</label>
            </div>
            <div className='col-9'>
              <select
                value={this.state.form.discount_type}
                className='form-control'
                onChange={(event) => this._discountTypeChange(event)}
              >
                {
                  this.discount_type.map((list, i) => (
                    <option key={i} value={list.value}>{list.label}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Discount Amount</label>
            </div>
            {
              this.state.isDiscount === true
                ? <div className='col-9'>
                  <input type='number' min={0} max={100} className='form-control' value={this.state.form.discount} onChange={(event) => this._inputChange(event, 'discount')} />
                </div>
                : <div className='col-9'>
                  <input type='number' min={0} className='form-control' value={this.state.form.discount} onChange={(event) => this._inputChange(event, 'discount')} />
                </div>
            }
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Weight</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                required
                className='form-control'
                value={this.state.form.weight}
                onChange={(event) => this._inputChange(event, 'weight')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Dimension</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Length x Width x Height'
                className='form-control'
                value={this.state.form.dimension}
                onChange={(event) => this._inputChange(event, 'dimension')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Supplier</label>
            </div>
            <div className='col-9'>
              <Select
                options={supplierPicker}
                name='suplier-picker'
                required
                value={this.state.selectedSupplier}
                onChange={(selectedSupplier) => this._supplierChange(selectedSupplier)}
                placeholder='Pick a Suplier'
                
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description</label>
            </div>
            <div className='col-9'>
              <textarea
                rows='5'
                className='form-control'
                value={this.state.form.description}
                onChange={(event) => this._inputChange(event, 'description')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Source</label>
            </div>
            <div className='col-9'>
              <select
                value={this.state.form.iso_code}
                className='form-control'
                onChange={(event) => this._inputChange(event, 'iso_code')}
              >
                {
                  this.iso_code.map((list, i) => (
                    <option key={i} value={list.value}>{list.label}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  category: state.category,
  supplier: state.supplier
})

const dispatchToProps = (dispatch) => ({
  updateInventory: (data) => dispatch(InventoryActions.updateInventoryRequest(data)),
  getSupplier: (data) => dispatch(SupplierActions.getSupplierRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateInventory)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/UpdateInventory.js